<template>
  <p :class="wrapperClass ? wrapperClass : 'a-input-wrapper-column'">
    <label
      v-if="label"
      :for="$attrs.name"
    >
      {{ label }}
    </label>

    <select
      :class="inputError ? `a-input-primary a-input-danger ${inputClass}` : `a-input-primary ${inputClass}`"
      v-model="selected"
    >
      <option
        selected
        value=""
      >
      </option>
      <option
        v-for="element in elements"
        :key="element[keyField]"
        :value="element[keyField]"
        :selected="element[keyField] === value ? true : false"
      >
        {{ element[textField] }}
      </option>
    </select>
    <small
      v-if="inputError"
      class="text-color-danger"
    >
      {{ messageError }}
    </small>
  </p>
</template>

<script>
export default {
  name: 'AtomSelectPrimaryTimeout',
  inheritAttrs: false,

  props: {
    elements: Array,
    inputError: Boolean,
    keyField: String,
    label: String,
    messageError: String,
    inputClass: String,
    textField: String,
    value: [String, Number],
    wrapperClass: String
  },

  watch: {
    selected (newValue) {
      let c = this
      if (this.timeout) {
        clearTimeout(this.timeout)
        this.timeout = null
      }
      this.timeout = setTimeout(function () {
        c.$emit('input', newValue)
      }, 500)
    }
  },

  mounted () {
    this.selected = this.value
  },

  data () {
    return {
      timeout: null,
      selected: null
    }
  }
}
</script>
